import Request from '../data/request'
import UserToAdd from "../../gd-modals/users/model/add-user"

export default class ApiChat {

    constructor() {}

    newOneToOneChatRoom(companyId: ID, userId: ID) {
        return new Request(this, 'POST', 'new-chat', {
            systemType  : 1,
            companyId   : companyId,
            users       : [userId]
        })
    }

    newGroupChatRoom(name: string, companyId: ID, arrUsers: ID[]) {
        return new Request(this, 'POST', 'new-chat', {
            systemType  : 2,
            name        : name,
            companyId   : companyId,
            users       : arrUsers
        })
    }

    newProjectDiscussionChatRoom(name: string, companyId: ID, projectId: ID, arrUsers: ID[]) {
        return new Request(this, 'POST', 'new-chat', {
            systemType  : gd.const.chat.systemType.PROJECT_DISCUSSION,
            name        : name,
            companyId   : companyId,
            projectId   : projectId,
            users       : arrUsers
        })
    }

    // resetChatRooms() {
    //     return new Request(this, 'GET', 'session/reset-chat-rooms')
    // }

    chatView(chatRoomId: ID) {
        return new Request(this, 'GET', 'chat/'+chatRoomId)
    }

    chatAllMessages(chatRoomId: ID) {
        return new Request(this, 'GET', 'chat/'+chatRoomId+'/all-messages')
    }

    newChatMessage(chatRoomId: ID, message: string, messageRTF: any, attachments: any, tempId: ID) {
        return new Request(this, 'POST', 'chat/'+chatRoomId+'/new-message', {
            message, messageRTF, attachments, tempId
        })
    }

    editChatMessage(chatRoomId: ID, messageId: ID, message: string, messageRTF: any, attachments?: any) {
        return new Request(this, 'PUT', 'chat/'+chatRoomId+'/message/'+messageId, {
            message, messageRTF, attachments
        })
    }

    deleteChatMessage(chatRoomId: ID, messageId: ID) {
        return new Request(this, 'DELETE', 'chat/'+chatRoomId+'/message/'+messageId)
    }

    deleteChatMessageAttachment(chatRoomId: ID, messageId: ID, fileId: ID) {
        return new Request(this, 'DELETE', 'chat/'+chatRoomId+'/message/'+messageId+'/attachment/'+fileId)
    }

    addChatMessageAttachment(chatRoomId: ID, messageId: ID, fileObj: any) {
        return new Request(this, 'POST', 'chat/'+chatRoomId+'/message/'+messageId, {
            fileObj
        })
    }

    newUsers(chatRoomId: ID, arrUsers: ID[]) {
        return new Request(this, 'POST', 'chat/'+chatRoomId+'/new-users', {
            users: arrUsers
        })
    }

    static createChatUsers(chatRoomId: ID, usersToCreate:UserToAdd[]) {
        const userIds = _.map(usersToCreate, (userToAdd: UserToAdd)=>{
            return userToAdd.id
        })

        return new Request(this, 'POST', 'chat/'+chatRoomId+'/new-users', {
            users: userIds
        })
    }

    chatLeave(chatRoomId: ID) {
        return new Request(this, 'POST', 'chat/'+chatRoomId+'/leave')
    }

    chatDelete(chatRoomId: ID) {
        return new Request(this, 'DELETE', 'chat/'+chatRoomId+'/delete')
    }

    chatRename(chatRoomId: ID, name: string) {
        return new Request(this, 'PUT', 'chat/'+chatRoomId+'/rename', {
            name: name
        })
    }

    markAsRead(chatRoomId: ID) {
        return new Request(this, 'POST', 'chat/'+chatRoomId+'/mark-as-read')
    }

    removeUsers(chatRoomId: ID, arrUsers: ID[]) {
        return new Request(this, 'POST', 'chat/'+chatRoomId+'/remove-users', {
            users: arrUsers
        })
    }

    star(chatRoomId: ID, messageId: ID) {
        return new Request(this, 'POST', 'chat/'+chatRoomId+'/message/'+messageId+'/star')
    }

    unstar(chatRoomId: ID, messageId: ID) {
        return new Request(this, 'DELETE', 'chat/'+chatRoomId+'/message/'+messageId+'/star')
    }

    //discussion
    updateTodo(chatRoomId: ID, data: any) {
        return new Request(this, 'PUT', 'chat/{0}/action-items'.f(chatRoomId), {
            todo: data
        })
    }
}